'use strict';

module.exports = function () {
  /**
   * Since isPublished is used as a required validator, if a document is custom,
   * we want to return false so that nothing that is normally required for a published doc or a document
   * whose parent is published is required in this case
   */
  if (this && this.isCustom) {
    return false;
  }

  if (this && this.parent) {
    return this.parent().status === 'Published';
  }

  return this.status === 'Published';
};